import { useQuery } from '@tanstack/react-query'
import { useLocation } from 'react-router-dom'

import { getCurrentValues } from '../../utils/programsUtils'
import { getProgramList } from '../../api/program'
import { QUERY_KEYS } from '../../constants/queryKeys'

function useGetPrograms(filter: boolean = false) {
   const location = useLocation()
   const params = getCurrentValues(location.search)

   return useQuery({
      queryKey: [QUERY_KEYS.GET_PROGRAMS, params],
      queryFn: async () => {
         const result = await getProgramList(params)
         if (filter) {
            const filtered = result.items.filter((item) => item.isDefault)
            return {
               items: filtered,
               totalSize: filtered.length,
            }
         }
         return {
            items: result.items,
            totalSize: result.totalSize,
         }
      },
   })
}

export { useGetPrograms }
export default useGetPrograms
